// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"48956514de3502f8024b","888":"8fb9a341d8f33e52a196"}[chunkId] + ".css";
};